import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from './ButtonLoading.module.scss';

var ButtonLoading = function ButtonLoading(_ref) {
  var _ref$gain = _ref.gain,
      gain = _ref$gain === void 0 ? false : _ref$gain,
      _ref$dl_btn = _ref.dl_btn,
      dl_btn = _ref$dl_btn === void 0 ? false : _ref$dl_btn;
  return /*#__PURE__*/_jsxs("ul", {
    className: [styles.loading, gain ? styles.gainBtn : '', dl_btn ? styles.center : ''].join(' '),
    children: [/*#__PURE__*/_jsx("li", {
      className: styles.item
    }), /*#__PURE__*/_jsx("li", {
      className: styles.item
    }), /*#__PURE__*/_jsx("li", {
      className: styles.item
    })]
  });
};

export default ButtonLoading;